import { render, staticRenderFns } from "./ValuationOfShares.vue?vue&type=template&id=2c68a65c&scoped=true&"
import script from "./ValuationOfShares.vue?vue&type=script&lang=js&"
export * from "./ValuationOfShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68a65c",
  null
  
)

export default component.exports